import { DOCUMENT_CLASSIFICATIONS } from "@/constants/documents";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";

type UploadDocumentTypeFilterProps = {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
};

export const UploadDocumentTypeFilter = ({
  value,
  onValueChange,
  className,
}: UploadDocumentTypeFilterProps) => {
  // Get unique categories for filter options
  const documentCategories = Array.from(
    new Set(DOCUMENT_CLASSIFICATIONS.map((docType) => docType.category))
  ).sort();

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className || "w-[250px]"}>
        <SelectValue placeholder="Filter by document type" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Document Types</SelectItem>
        {documentCategories.map((category) => (
          <SelectItem key={category} value={category}>
            {DOCUMENT_CLASSIFICATIONS.find((doc) => doc.category === category)
              ?.title || category}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
